module.exports = __webpack_public_path__ + "img/hotdog-top-ma005.32a50afc.jpg";